import sortBy from 'lodash/sortBy';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '@eti/providers';
import { css, cx, mediaQueries } from '@eti/styles';
import { AIRLINES } from '../../../../../constants/searchFiltersConstants';
import type { SearchOnResultPageMarketingCarriersType } from '../../../models';
import CheckboxFilter from './CheckboxFilter';
import type { Filters } from './MobileFilters';

const filterStyles = css`
  @media ${mediaQueries.medium.down} {
    & header {
      padding-bottom: 0;
    }
  }
`;

const initiallyShownAirlines = 6;

type DestinationState = {
  fromDestinationPage?: boolean;
};

interface AirlinesProps {
  className?: string;
  isInitiallyExpanded: boolean;
  isToggleable: boolean;
  onFilter: (filterOptions: { [key: string]: string[] | null }) => void;
  selectedFilters?: Filters | null;
  marketingCarriers: SearchOnResultPageMarketingCarriersType;
}

const Airlines = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  onFilter,
  selectedFilters,
  marketingCarriers,
}: AirlinesProps) => {
  const { t } = useTranslation();
  const history = useHistory<DestinationState>();
  const navigatingFromDestinationPage = history?.location?.state?.fromDestinationPage;

  return (
    <CheckboxFilter
      className={cx(filterStyles, className)}
      isInitiallyExpanded={isInitiallyExpanded}
      isToggleable={isToggleable}
      label={t('Result.SearchFilters.Airlines.Text')}
      name={AIRLINES}
      onFilter={onFilter}
      options={sortBy(marketingCarriers, ['name'])}
      selectedValues={selectedFilters ? selectedFilters[AIRLINES] : []}
      shouldShowResetButton={false}
      showMoreLabel={t(
        'Result.SearchFilters.Airlines.ShowMore.Button',
        marketingCarriers && marketingCarriers.length - initiallyShownAirlines,
      )}
      shownOptionsLimit={
        navigatingFromDestinationPage ? marketingCarriers?.length : initiallyShownAirlines
      }
    />
  );
};

export default Airlines;
